const findPwd = {
  name: 'findPwd',
  path: 'findPwd',
  component: resolve => require(['../../../pages/custom/find-pwd'], resolve)
}

export default findPwd



// WEBPACK FOOTER //
// ./src/router/custom/find-pwd/index.js